import React from 'react'
import { useSelector } from 'react-redux'
import IncentiveBox from 'components/Utils/IncentiveBox'
import { getNoteResourcesUsage } from 'data/organizationResourcesUsage/selectors'

const NewNoteLimitIncentive = () => {
  const { current, limit } = useSelector(getNoteResourcesUsage)

  return (
    <IncentiveBox
      className="entity-highlight margin-bottom-small"
      incentiveId="NotesLimit"
      title={`You have ${Math.max(limit - current, 0)} free docs left`}
      description="Upgrade to keep writing"
    />
  )
}

export default NewNoteLimitIncentive
